module.exports = __webpack_public_path__ + "img/m_c.61be96a9.png";